import { brandLinkMarkup } from "../config/brand.js";
import { REGISTRATION_STATE, isRegistrationActivationReady } from "../config/registration-state.js";

export function legalBrandMarkup() {
  return brandLinkMarkup({ className: "legal-brand", logoClassName: "legal-brand-mark" });
}

export function legalHeaderMarkup(active) {
  const links = [
    { id: "home", label: "Home", href: "/" },
    { id: "signup", label: "Create Account", href: REGISTRATION_STATE.signupRoute },
    { id: "terms", label: "Terms of Service", href: REGISTRATION_STATE.termsRoute },
    { id: "contact", label: "Contact Staff", href: REGISTRATION_STATE.contactRoute },
  ];
  const registrationReady = isRegistrationActivationReady(REGISTRATION_STATE);
  return `
    <header class="legal-topbar">
      ${legalBrandMarkup()}
      <nav aria-label="Primary navigation">
        ${links.map((item) => item.id === "signup" && !registrationReady ? `<span class="legal-nav-locked" aria-disabled="true">${item.label} <small>LOCKED</small></span>` : `<a href="${item.href}"${item.id === active ? ' aria-current="page"' : ""}>${item.label}</a>`).join("")}
      </nav>
      <span class="legal-lock"><i aria-hidden="true"></i>${REGISTRATION_STATE.statusLabel}</span>
    </header>`;
}

